// extracted by mini-css-extract-plugin
module.exports = {"input":"styles-module__input___1eMrR"};